/* tslint:disable */
/* eslint-disable */
export enum BusinessCategory {
  B2C = 'B2C',
  B2B = 'B2B',
  B2G = 'B2G',
  B2I = 'B2I',
}
